import React, { PropsWithChildren } from 'react';
import { withTheme } from '@material-ui/core';
import cx from 'classnames';

import { MenuItem } from '../menu/MenuItem.view';
import SesamLink from '../common/Links/SesamLink';

import type { Theme } from '../../types/common.types';

const MenuActionLink: React.FC<
  PropsWithChildren<{
    disabled?: boolean;
    label: string;
    theme: Theme;
    to: string;
    testId?: string;
    linkClassName?: string;
  }>
> = ({ children, disabled = false, label, to, theme, linkClassName, testId, ...props }) => (
  <MenuItem data-testid={testId} {...props}>
    {disabled ? (
      <span className="menu__action" style={{ color: theme.palette.action.disabled }}>
        {label}
        {children}
      </span>
    ) : (
      <SesamLink
        className={cx('menu__action', linkClassName)}
        style={{ color: theme.palette.text.primary }}
        to={to}
      >
        {label}
        {children}
      </SesamLink>
    )}
  </MenuItem>
);

// @ts-ignore
const Themed = withTheme(MenuActionLink);

export { Themed as MenuActionLink };
